import apiV2 from "api-v2";
import type {
  AwardEmailStatus,
  AwardsResponse,
  UpsertAwardsRequest,
} from "../types/award.type";
import { unwrap } from "newui/utils/apiResponse";

const awardsBase = (rfxId: number, evalId: number): string =>
  `/rfx/${rfxId}/evaluation/${evalId}/awards`;

export const getAwards = async (
  rfxId: number,
  evalId: number
): Promise<AwardsResponse> => {
  const response = await apiV2.get(awardsBase(rfxId, evalId));
  return unwrap<AwardsResponse>(response.data);
};

export const upsertAwards = async (
  rfxId: number,
  evalId: number,
  payload: UpsertAwardsRequest
): Promise<AwardsResponse> => {
  const response = await apiV2.put(awardsBase(rfxId, evalId), payload);
  return unwrap<AwardsResponse>(response.data);
};

const inviteBase = (rfxId: number, evalId: number, inviteId: number): string =>
  `${awardsBase(rfxId, evalId)}/${inviteId}`;

// Award/not-awarded decision attachments now upload via the shared chunked
// FileUpload flow (POST /file-upload/store, model: rfx_award_contract) — the
// preferred file-upload method. The bespoke contract endpoint was removed.

export interface ResendEmailResponse {
  email_status: Exclude<AwardEmailStatus, null>;
}

/**
 * Re-sends the award/not-awarded notification email for a supplier.
 * `POST /rfx/{rfxId}/evaluation/{evalId}/awards/{inviteId}/resend-email`
 */
export const resendAwardEmail = async (
  rfxId: number,
  evalId: number,
  inviteId: number
): Promise<ResendEmailResponse> => {
  const response = await apiV2.post(
    `${inviteBase(rfxId, evalId, inviteId)}/resend-email`
  );
  return unwrap<ResendEmailResponse>(response.data);
};
